import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/organisations/{organisationId}/payment-informations").GET();

export type GetCompanyPaymentInfoResponse = typeof endpoint.types.Res;

const call = createCall(endpoint, (request) => fetch(withAccountAuthHeaders(request)));

export async function getCompanyPaymentInfo(params: typeof endpoint.types.P) {
    return await call({ params });
}
